import { render, staticRenderFns } from "./Amendment.vue?vue&type=template&id=f3f7b740"
import script from "./Amendment.vue?vue&type=script&lang=js"
export * from "./Amendment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports